// extracted by mini-css-extract-plugin
export var avatar = "_rb-3";
export var avatarContainer = "_rb-2";
export var avatarSpacer = "_rb-5";
export var avatarSpacerContainer = "_rb-4";
export var avatarStackContainer = "_rb-1";
export var bubble = "_rb-0";
export var remainderBubble = "_rb-6";